import { type RoundAggregate } from "@engine/round/aggregate";

export class FailedLookupById extends Error {
  constructor(type: string, round: RoundAggregate, id: string) {
    const { result, path } = findObjectByKey(round, id);

    let message = `Failed to find ${type} by ID: ${id}`;
    if (result) {
      message += `  \nFound object with same id at path: ${path.join(" -> ")}`;
      message += `  \nObject: ${JSON.stringify(result, null, 2)}`;
    } else {
      message += `  \nNo object found in round with same id`;
    }

    super(message);
    this.name = "FailedLookupByUuid";
  }
}

export function findObjectByKey(
  obj: unknown,
  key: string,
): { result: unknown; path: string[] } {
  let result: unknown = null;
  let path: string[] = [];

  function recursiveSearch(
    obj: unknown,
    key: string,
    currentPath: string[],
  ): boolean {
    if (obj !== null && typeof obj === "object") {
      const objRecord = obj as Record<string, unknown>;
      for (const k in objRecord) {
        if (Object.prototype.hasOwnProperty.call(objRecord, k)) {
          if (k === key) {
            result = objRecord[k];
            path = currentPath.concat(k);
            return true;
          }
          if (recursiveSearch(objRecord[k], key, currentPath.concat(k))) {
            return true;
          }
        }
      }
    }
    return false;
  }

  recursiveSearch(obj, key, []);
  return { result, path };
}
